export interface IAnneeScolaire {
  id?: any;
  nom?: string | null;
  dateDebut?: string;
  dateCloture?: string;
  statutAnneeScolaire?: StatusAnneeScolaire;
  ecoleId: string;
}

export enum StatusAnneeScolaire {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CLOTUREE = 'CLOTUREE',
}

export const defaultValue: Readonly<IAnneeScolaire> = {
  id: null,
  nom: '',
  dateCloture: '',
  dateDebut: '',
  ecoleId: '',
  statutAnneeScolaire: StatusAnneeScolaire.INACTIVE,
};
